
import { Card, CardContent } from "./ui/card.tsx";
import { Button } from "./ui/button.tsx";
import { blogPosts, isPublished } from "../data/blogPosts";
import { Link } from "react-router-dom";

const BlogSection = () => {
  // Show only the first 3 blog posts on the main page
  const featuredPosts = blogPosts.filter(isPublished).slice(0, 3);

  return (
    <section id="blog" className="py-20 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Blog & Ratgeber
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Informative Artikel rund um das Leben alleine, Sicherheit im Alltag und moderne Technologien für mehr Wohlbefinden.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {featuredPosts.map((post) => (
            <Card key={post.id} className="hover:shadow-lg transition-shadow">
              <div className="aspect-video bg-gray-200 rounded-t-lg overflow-hidden">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {post.preview}
                </p>
                <Link to={`/blog/${post.slug || post.id}`}>
                  <Button variant="outline" className="w-full">
                    Weiterlesen
                  </Button>
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/blog">
            <Button className="bg-blue-600 hover:bg-blue-700 text-white">
              Alle Artikel anzeigen
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
